import { Link } from "@inertiajs/react";
import { Button, Card, Flex, Heading, Text } from "@radix-ui/themes";
import { Car, Plus } from "lucide-react";
import UserPageShell from "@/shared/users/UserPageShell";
import GarageGrid from "@/shared/cars/GarageGrid";
import type { UsersGarageProps } from "@/types/users_garage";

export default function Garage({ driver_cars }: UsersGarageProps) {
  return (
    <UserPageShell title="Garage">
      <Flex justify="between" align="center" gap="3" wrap="wrap">
        <Heading size="7">Garage</Heading>
        <Button asChild size="3">
          <Link href="/driver_cars/new">
            <Plus size={16} />
            Add car
          </Link>
        </Button>
      </Flex>

      {driver_cars.length > 0 ? (
        <GarageGrid cars={driver_cars} />
      ) : (
        <Card size="3">
          <Flex direction="column" align="center" gap="3" py="6">
            <Car size={40} color="var(--gray-8)" aria-hidden />
            <Text size="4" weight="bold">
              No cars yet
            </Text>
            <Text size="2" color="gray" align="center">
              Add your car to apply to drive, say you're going to events, and
              show up on the events you were at.
            </Text>
            <Button asChild size="3" variant="soft">
              <Link href="/driver_cars/new">Add your first car</Link>
            </Button>
          </Flex>
        </Card>
      )}
    </UserPageShell>
  );
}
